import type { ReactNode } from "react";
import { ContentContainer } from "./content-container";
import { HorizontalContainer } from "./horizontal-container";

interface PageContentProps {
  children: ReactNode;
  width?: "xx-small" | "x-small" | "small" | "medium" | "large" | "x-large";
}

export const PageContent = ({ children, width }: PageContentProps) => {
  return (
    <HorizontalContainer horizontalPlacement="center" width="full">
      <ContentContainer horizontalPlacement="center" width={width ?? undefined}>
        {children}
      </ContentContainer>
    </HorizontalContainer>
  );
};
